import { UserSigninStatus } from 'src/app/shared/enums/UserSigninStatus.enum';
import { UserSigninStatusModel } from '../../lobby/shared/models/lobby-user-signin-status.model';

export interface SignInStatus {
    isSignInSuccess: boolean,
    currentAssistingLobbyEntryId: number | null,
    currentAssistingLocationId: number | null
}

export function MapSigninStatus(status: UserSigninStatusModel | null): boolean {
    if (status && (status.statusId === UserSigninStatus.Idle || status.statusId === UserSigninStatus.Assisting)) {
        return true;
    } else {
        return false;
    }
}

/**
 * Maps UserSigninStatusModel to SignInStatus.
 * @param status - UserSigninStatusModel object to map from.
 * @returns SignInStatus - Mapped status indicating if sign-in is successful and current assisting details.
 */
export function MapSigninStatusWithCurrentAssisting(status: UserSigninStatusModel | null): SignInStatus {
    if (status != null && (status.statusId === UserSigninStatus.Idle || status.statusId === UserSigninStatus.Assisting)) {
        return {
            isSignInSuccess: true,
            currentAssistingLobbyEntryId: status.currentAssistingLobbyEntryId,
            currentAssistingLocationId: status.currentAssistingLocationId
        };
    } else {
        return {
            isSignInSuccess: false,
            currentAssistingLobbyEntryId: status?.currentAssistingLobbyEntryId || null,
            currentAssistingLocationId: status?.currentAssistingLocationId || null
        };
    }
}
